import logoBlanc from '../../logos/logo-engie-blanc.svg';
//import logoJAG from '../../logos/logo-jag.svg';
import { Flex } from "antd";
import { NJTab } from '@engie-group/fluid-design-system-react';
import { NJButton } from '@engie-group/fluid-design-system-react';
import './HeaderMenu.css';
import { useNavigate } from 'react-router-dom';
//import ModelSelector from '../ModelSelector';
import React, { useState, useEffect } from 'react';
import { useReferentials } from '../../context/ReferentialsContext';
import { useUser } from '../../context/UserContext';
import { oktaEnabled } from '../../config';
import { getValidOktaToken } from '../../api';
import { useOktaAuth } from "@okta/okta-react";


function HeaderMenu({ username }) {

    const { referentials } = useReferentials();
    const userInfo = useUser();
    const { oktaAuth } = useOktaAuth();
    const navigate = useNavigate();

    const [enableAdmin, setEnableAdmin] = useState(false);
    const [showOktaToken, setShowOktaToken] = useState(false);

    useEffect(() => {

        // Enable admin menu if running on localhost or if okta is disabled
        if ((window.location.hostname === 'localhost') || !oktaEnabled) {
            setEnableAdmin(true);
        } else {
            let username = userInfo?.preferred_username;
            if (username && referentials?.admin && userInfo) {
                let gid = username.split('@')[0].toUpperCase();
                setEnableAdmin(referentials.admin.includes(gid));
            }
        }
    }, [referentials, userInfo]);

    useEffect(() => {
        // Enable showOktaToken if current gid is in REACT_APP_SHOW_OKTA_TOKEN_FOR_USERS
        let username = userInfo?.preferred_username;
        if (oktaEnabled && oktaAuth && username && process.env.REACT_APP_SHOW_OKTA_TOKEN_FOR_USERS) {
            //debugger
            let gid = username.split('@')[0].toUpperCase();
            const showOktaTokenUsers = process.env.REACT_APP_SHOW_OKTA_TOKEN_FOR_USERS.toUpperCase().split(',');
            if (showOktaTokenUsers.includes(gid)) {
                setShowOktaToken(true);
            }
        }
    }, [userInfo, oktaAuth]);

    return (
        <>
            <Flex
                className='header-menu-container'
                justify='space-between'
                align='center'>

                <Flex justify='flex-start' align='center'>
                    <span className='header-menu-logo'>
                        <a href="/dashboard"
                            onClick={(e) => {
                                e.preventDefault(); // Prevent default navigation
                                navigate('/dashboard');
                            }}
                        >
                            <img
                                className='header-menu-engie-logo'
                                src={logoBlanc}
                                alt="ENGIE"
                            />
                            {/* 
                            <img
                                className='header-menu-logo-img'
                                src={logoBlanc}
                                src={logoJAG}
                                alt="ENGIE"
                            />
                            */}
                        </a>
                    </span>
                    <span className='header-menu-title'>
                        Job Ad Generator
                    </span>
                    <span className='header-menu-tabs'>
                        <div className='nj-tab'>
                            <div className='nj-tab__items' role='tablist'>
                                <NJTab
                                    id="dashboard"
                                    label="Dashboard"
                                    isActive={window.location.pathname === '/dashboard'}
                                    isDisabled={false}
                                    onClick={() => navigate('/dashboard')}
                                />
                                {enableAdmin &&
                                    <NJTab
                                        id="admin"
                                        label="Admin"
                                        isActive={window.location.pathname === '/admin'}
                                        isDisabled={false}
                                        onClick={() => navigate('/admin')}
                                    />
                                }
                            </div>
                        </div>
                    </span>
                </Flex>
                {/* <ModelSelector /> */}
                <Flex justify='flex-start' align='center' gap={10}>
                    {showOktaToken &&
                        <NJButton
                            icon="visibility"
                            label="Copy Okta token"
                            scale="sm"
                            variant="ai"
                            onClick={async (e) => {
                                e.preventDefault();
                                // Get valid okta token
                                const token = await getValidOktaToken(oktaAuth);
                                // Copy to clipboard as html and text
                                const clipboardItem = new ClipboardItem({
                                    'text/plain': new Blob([token], { type: 'text/plain' })
                                });
                                navigator.clipboard.write([clipboardItem])
                                    .then(() => alert(`Token copied to clipboard: ${token}`))
                                    .catch(err => console.error('Error copying text: ', err));
                            }}
                        />
                    }
                    {!oktaEnabled &&
                        <NJButton
                            icon="key"
                            label="Set Okta token"
                            scale="sm"
                            variant="ai"
                            onClick={() => {
                                let token = prompt('Enter your Okta token');
                                if (token) {
                                    localStorage.setItem('force-token', token);
                                    alert('Token saved in local storage');
                                }
                            }}
                        />
                    }
                    <div className='header-menu-username'>{username}</div>
                    {/*
                <span>
                    <a href="#"
                        onClick={(e) => {
                            e.preventDefault(); // Prevent default navigation
                            navigate('/dashboard');
                        }}
                    >
                        <img
                            className='header-menu-engie-logo'
                            src={logoBlanc}
                            alt="ENGIE"
                        />
                    </a>
                </span>
                 */ }
                </Flex>
            </Flex>
        </>
    )
}

export default HeaderMenu;
